import { Fragment, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { formatDetailPage } from "_helper/utils";
import { Breadcrumbs } from "AbstractElements";
import TheForm from "Components/Common/Component/form/TheForm";
import { useCrudApi } from "hook/useCrudApi";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { SampleModule } from "models/sample-module";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { parent, title, useFormFields } from "./constant";

export const DetailPage = () => {
  const { useGetById } = useCrudApi<SampleModule>("SampleModule");
  const { toList, toEdit } = useResourceNavigate("ho-so-don-vi");
  const formFields = useFormFields();
  const { id } = useParams();

  const { data, isFetched } = useGetById(id ?? "");

  const useFormReturn = useForm();
  const { reset } = useFormReturn;

  useEffect(() => {
    reset(formatDetailPage(data));
  }, [data, isFetched]);

  return (
    <Fragment>
      <Breadcrumbs title={title} parent={parent} mainTitle={title} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <TheForm
                  {...useFormReturn}
                  items={formFields as any}
                  textOnly
                  onEdit={() => toEdit(id!)}
                  onCancel={toList}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
